import { IApplicationState } from '../../types/redux';

export function selectPhoneError(state: IApplicationState) {
  return state.phone.fetchPhoneError;
}
